export const defaultZIndexes = {
  frontpageBooks: 0,
  frontpageSplashImage: 0,
  sequenceBanner: 0,
  reviewExpandButton: 1,
  reviewVotingCanvas: 1,
  bestOfLessWrongAdminHeader: 1,
  modTopBar: 1,
  spotlightItem: 1,
  editorPresenceList: 1,
  postsPageSplashHeader: 1,
  singleColumnSection: 2,
  spotlightItemCloseButton: 2,
  commentsMenu: 2,
  sequencesPageContent: 2,
  sequencesImageScrim: 2,
  linkCard: 2,
  editSequenceTitleInput: 3,
  postsVote: 2,
  postItemAuthor: 2,
  singleLineCommentMeta: 3,
  postItemTitle: 3,
  sidebarHoverOver: 3,
  sidebarActionMenu: 3,
  commentPermalinkIcon: 3,
  newWikiTagButton: 3,
  reviewVotingMenu: 4,
  singleLineCommentHover: 4,
  questionPageWhitescreen: 4,
  footerNav: 4,
  textbox: 5,
  styledMapPopup: 6,
  nextUnread: 999,
  sunshineSidebar: 1000,
  reactionsFooter: 1001,
  drawer: 1400,
  modal: 1450,
  intercomButton: 1400,
  blurredBackgroundModal: 1350, // lower than intercom
  confirmLogoutModal: 1351,
  overflowNavButtons: 1352,
  languageModelChatButton: 1030,
  sideCommentBox: 1040,
  languageModelChat: 1041,
  postItemMenu: 1050,
  snackbar: 1400,
  searchResults: 1450, // higher than intercom
  tabNavigation: 1101,
  hideTableOfContentsButton: 1200,
  header: 1300,
  karmaChangeNotifier: 1400,
  backdrop: 1310,
  notificationsMenu: 1500,
  splashHeaderImageOptions: 2000,
  gatherTownIframe: 9999, // 1000001 higher than everything except intercom
  afNonMemberPopup: 9999,
  lwPopper: 10000,
  lwPopperTooltip: 10001,
  loginDialog: 10002,
  searchBar: 100000,
  commentBoxPopup: 10000000001, // has to be higher than Intercom,
  // ckEditorToolbar: 10000000002, // has to be higher than commentBoxPopup, (note: the css had to be applied in an scss file, "_editor.scss", but the position is listed here for ease of reference)
  petrovDayButton: 6,
  petrovDayLoss: 1000000,
} as const;

export type ZIndexName = keyof typeof defaultZIndexes;

export type ZIndexMap = Record<ZIndexName, number>;
